import { render, staticRenderFns } from "./detailedList.vue?vue&type=template&id=023a96e3&scoped=true"
import script from "./detailedList.vue?vue&type=script&lang=js"
export * from "./detailedList.vue?vue&type=script&lang=js"
import style0 from "./detailedList.vue?vue&type=style&index=0&id=023a96e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023a96e3",
  null
  
)

export default component.exports